"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _ActivityType = _interopRequireDefault(require("MeetingsBase/models/ActivityType"));

var _Availability = _interopRequireDefault(require("MeetingsBase/models/Availability"));

var _DisplayInfo = _interopRequireDefault(require("MeetingsBase/models/DisplayInfo"));

var _FormField = _interopRequireDefault(require("MeetingsBase/models/FormField"));

var _LegalConsentOptions = _interopRequireDefault(require("MeetingsBase/models/LegalConsentOptions"));

var _Reminder = _interopRequireDefault(require("MeetingsBase/models/Reminder"));

var _availability = require("MeetingsBase/utils/availability");

var _enums = require("MeetingsBase/constants/enums");

var _dates = require("MeetingsBase/constants/dates");

var defaults = {
  activityType: null,
  availability: new _Availability.default(),
  // only used to store selected time options while editing meeting links
  availabilityTimeList: (0, _immutable.List)(),
  customAvailabilityStartDate: null,
  customAvailabilityEndDate: null,
  description: null,
  displayInfo: new _DisplayInfo.default(),
  durations: new _immutable.List([_dates.ZERO_DURATION]),
  formFields: (0, _immutable.List)(),
  includeDescriptionInReminder: false,
  language: null,
  legalConsentEnabled: false,
  legalConsentOptions: null,
  locale: null,
  location: null,
  meetingBufferTime: _I18n.default.moment.duration('00:15:00').asMilliseconds(),
  ownerPrioritized: false,
  minimumNoticeTime: _I18n.default.moment.duration('00:15:00').asMilliseconds(),
  redirectUrl: null,
  reminders: (0, _immutable.List)(),
  sendReminder: false,
  shouldAutoSubmit: false,
  subject: null,
  timezone: 'Europe/Dublin',
  videoConferenceExtensionAppId: null,
  weeksToAdvertise: 2,
  startTimeIncrementMinutes: _enums.START_TIME_INTERVALS.FIFTEEN,
  confirmationEmailEnabled: true,
  pushBackTime: _I18n.default.moment.duration('00:15:00').asMilliseconds()
};

var getVisibleFormOptions = function getVisibleFormOptions(formFields) {
  return formFields.map(function (field) {
    if (_enums.FORM_FIELDS_WITH_OPTIONS.indexOf(field.type) > -1) {
      var visibleOptions = field.options.filter(function (option) {
        return !option.hidden;
      });
      field.options = visibleOptions;
    }

    return field;
  });
};

var LinkCustomParams =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(LinkCustomParams, _Record);

  function LinkCustomParams() {
    (0, _classCallCheck2.default)(this, LinkCustomParams);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LinkCustomParams).apply(this, arguments));
  }

  (0, _createClass2.default)(LinkCustomParams, [{
    key: "convertToJSON",
    value: function convertToJSON() {
      var json = this.update('legalConsentOptions', function (legalConsentOptions) {
        return legalConsentOptions ? legalConsentOptions.convertToJSON() : null;
      }).toJS();
      json.pushBackTime = this.minimumNoticeTime;
      delete json.minimumNoticeTime;
      delete json.availabilityTimeList;
      return json;
    }
  }], [{
    key: "from",
    value: function from(json) {
      if (json.timezone) {
        json.timezone = _I18n.default.moment.tz.names().includes(json.timezone) ? json.timezone : 'Europe/Dublin';
      }

      var activityType = json.activityType && json.activityType !== '' ? _ActivityType.default.from(json.activityType) : null;
      var legalConsentOptions = json.legalConsentOptions !== null ? _LegalConsentOptions.default.from(json.legalConsentOptions) : null;

      var availability = _Availability.default.from(json.availability);

      return new LinkCustomParams((0, _extends2.default)({}, json, {
        activityType: activityType,
        availability: availability,
        availabilityTimeList: (0, _availability.getChunkListFromRecord)(availability),
        displayInfo: _DisplayInfo.default.from(json.displayInfo),
        durations: (0, _immutable.List)(json.durations),
        formFields: (0, _immutable.List)(getVisibleFormOptions(json.formFields).map(function (field) {
          return _FormField.default.from(field);
        })),
        legalConsentOptions: legalConsentOptions,
        ownerPrioritized: json.ownerPrioritized || false,
        minimumNoticeTime: json.pushBackTime,
        reminders: json.reminders ? (0, _immutable.List)(json.reminders.map(function (reminder) {
          return new _Reminder.default(reminder);
        })) : (0, _immutable.List)(),
        videoConferenceExtensionAppId: json.videoConferenceExtensionAppId,
        weeksToAdvertise: json.weeksToAdvertise,
        startTimeIncrementMinutes: json.startTimeIncrementMinutes,
        confirmationEmailEnabled: json.confirmationEmailEnabled,
        pushBackTime: json.pushBackTime
      }));
    }
  }]);
  return LinkCustomParams;
}((0, _immutable.Record)(defaults));

exports.default = LinkCustomParams;
module.exports = exports.default;